import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  className = '',
  label,
  error,
  id,
  ...props
}: TextareaProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-188">
      {label && <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-slate-700" data-id="element-189">
          {label}
        </label>}
      <textarea id={inputId} className={`w-full min-h-[120px] rounded-lg border bg-white px-4 py-3 text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : 'border-slate-200'} ${className}`} {...props} data-id="element-190" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-191">{error}</p>}
    </div>;
}